export const STATUS_BADGE = {
  active: "bg-green-100 text-green-700",
  pending: "bg-amber-100 text-amber-700",
  none: "bg-stone-100 text-stone-500",
};

export const STATUS_LABEL = { active: "Attivo", pending: "In attesa", none: "Nessuno" };

export const PLAN_LABEL = { base: "Base", premium: "Premium Digitale", luxury: "Premium Fisico" };

export const ACTIVITY_LABELS = { sedentary: "Sedentario", light: "Leggero", moderate: "Moderato", active: "Attivo" };

export const formatDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("it-IT", { day: "numeric", month: "short", year: "numeric" });
  } catch {
    return "—";
  }
};
